/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Align_Left_Right_Justify_Left_PosInputs */



/**
* | output |
* | --- |
* | "Right Justify / Left Position" |
*
* @param {Align_Left_Right_Justify_Left_PosInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const align_left_right_justify_left_pos = /** @type {((inputs?: Align_Left_Right_Justify_Left_PosInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Align_Left_Right_Justify_Left_PosInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Justification Droite / Position Gauche")
	if (locale === "de") return /** @type {LocalizedString} */ ("Rechtsbündig / Linksposition")
	if (locale === "it") return /** @type {LocalizedString} */ ("Giustifica a destra / Posizione a sinistra")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Выравнивание по правому краю / Положение по левому краю")
	if (locale === "es") return /** @type {LocalizedString} */ ("Justificar a la derecha / Posición a la izquierda")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("右对齐/左对齐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("右揃え / 左揃え")
	if (locale === "hi") return /** @type {LocalizedString} */ ("दाईं ओर संरेखित करें / बाईं ओर स्थित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Justificar à direita / Posicionamento à esquerda")
	return /** @type {LocalizedString} */ ("Right Justify / Left Position")
});